/** Frame nearest the center for a pinned progress of 0 to 1. */
export const getReelActiveIndex = (progress: number, count: number) =>
  Math.min(count - 1, Math.max(0, Math.round(progress * (count - 1))));

/**
 * How far from dead center a frame may sit and still count as "in": a fifth
 * of a frame. Past that, neither frame plays while the strip moves.
 */
export const REEL_FOCUS_TOLERANCE = 0.2;

/**
 * The frame that should play: the nearest one, but only once it fills most
 * of the center. Returns null between frames.
 */
export const getReelPlayingIndex = (
  progress: number,
  count: number,
  tolerance = REEL_FOCUS_TOLERANCE,
) => {
  const position = Math.min(1, Math.max(0, progress)) * (count - 1);
  const nearest = Math.round(position);
  return Math.abs(position - nearest) <= tolerance ? nearest : null;
};

/** Pinned progress that centers frame `index`. */
export const getReelProgressFor = (index: number, count: number) =>
  count > 1 ? index / (count - 1) : 0;

/** "03 / 06" */
export const formatReelCounter = (index: number, count: number) =>
  `${String(index + 1).padStart(2, "0")} / ${String(count).padStart(2, "0")}`;
